import { useSelector, connect } from 'react-redux';
import React from 'react';

import { getUserInfo } from '../selectors';
import UnleashPermissions from 'shared/constants/unleashPermissions';
import { NewButtons } from './NewScheduleButtons';
import { ButtonsProps } from '../types';
import { Button } from './Button';
import { StoreState } from 'state/rootReducer';
import * as actions from 'state/schedule/actions';

export const ScheduleButtonsContainer = (props: ButtonsProps) => {
  const { unleash_permissions } = useSelector(getUserInfo);
  if (unleash_permissions?.includes(UnleashPermissions.NewScheduleButtons)) {
    return <NewButtons {...props} />;
  }
  return <Button {...props} />;
};

const mapStateToProps = (state: StoreState) => ({
  userData: state.userInfo.userData,
  isFetching: state.schedule.isFetching,
});

export default connect(mapStateToProps, actions)(ScheduleButtonsContainer);
